module.exports = __webpack_public_path__ + "img/img4_4.a25ea163.jpeg";